import { createContext, useContext, useState } from "react";

export const MatchPreviewFiltersContext = createContext({
    searchInput: "",
    setSearchInput: () => { },
    countriesList: [],
    setCountriesList: () => { },
    seasonsAndCupsList: [],
    setSeasonsAndCupsList: () => { },
    selectedSeasonsAndCups: [],
    setSelectedSeasonsAndCups: () => { },
    selectedCountries: [],
    setSelectedCountries: () => { },
    leaguesList: [],
    setLeaguesList: () => { },
    selectedLeagues: [],
    setSelectedLeagues: () => { },
    leaguesListForSeason: [],
    setLeaguesListForSeason: () => { },
    date: [],
    setDate: () => { },
    deffered: "",
    setDeffered: () => { },
    isLoading: false,
    setIsLoading: () => { },

    matchPreviewFiltersModalOpen: false, setMatchPreviewFiltersModalOpen: () => { },
    searchSeasonsCups: "",
    setSearchSeasonsCups: () => { },
    searchCountries: "",
    setSearchCountries: () => { },
    searchLeagues: "",
    setSearchLeagues: () => { },

});

const MatchPreviewFiltersProvider = ({ children }) => {


    const [searchInput, setSearchInput] = useState("");
    const [searchSeasonsCups, setSearchSeasonsCups] = useState("");
    const [searchCountries, setSearchCountries] = useState("");
    const [searchLeagues, setSearchLeagues] = useState("");

    const [countriesList, setCountriesList] = useState([]);
    const [selectedCountries, setSelectedCountries] = useState([]);

    const [leaguesList, setLeaguesList] = useState([]);
    const [selectedLeagues, setSelectedLeagues] = useState([])
    const [leaguesListForSeason, setLeaguesListForSeason] = useState([]);


    const [seasonsAndCupsList, setSeasonsAndCupsList] = useState({
        seasons: [],
        cups: [],
    });
    const [selectedSeasonsAndCups, setSelectedSeasonsAndCups] = useState({
        seasons: [],
        cups: [],
    });

    const newDateBefore = new Date();
    const newDateAfter = new Date();
    const date4DaysBefore = new Date(
        newDateBefore.setDate(newDateBefore.getDate() - 4)
    );
    const date4daysAfter = new Date(
        newDateAfter.setDate(newDateAfter.getDate() + 4)
    );
    const [date, setDate] = useState([date4DaysBefore, date4daysAfter]);
    const [deffered, setDeffered] = useState("all")
    const [isLoading, setIsLoading] = useState(false);

    const [matchPreviewFiltersModalOpen, setMatchPreviewFiltersModalOpen] = useState(false)



    return (
        <MatchPreviewFiltersContext.Provider
            value={{
                searchInput, setSearchInput,
                searchSeasonsCups, setSearchSeasonsCups,
                searchCountries, setSearchCountries,
                searchLeagues, setSearchLeagues,
                countriesList, setCountriesList,
                seasonsAndCupsList, setSeasonsAndCupsList,
                selectedSeasonsAndCups, setSelectedSeasonsAndCups,
                selectedCountries, setSelectedCountries,
                leaguesList, setLeaguesList,
                selectedLeagues, setSelectedLeagues,
                leaguesListForSeason, setLeaguesListForSeason,

                date, setDate,
                deffered, setDeffered,
                isLoading, setIsLoading,
                matchPreviewFiltersModalOpen, setMatchPreviewFiltersModalOpen,

            }}
        >
            {children}
        </MatchPreviewFiltersContext.Provider>
    );
};

export const useMatchPreviewFiltersService = () =>
    useContext(MatchPreviewFiltersContext);
export default MatchPreviewFiltersProvider;
